import React, { useEffect, useState } from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { BookingSkecheduleStyled } from "./styled";
import {
  RENDER_BOOKING_DATE_CHANGED,
  ROOM_BOOKING_RENDER_STATUS,
} from "utils/functions/roomBooking";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { userService } from "apiServices";
import { AlertControl } from "components/Modals/Alert";
import { Displays, Icons, Modals } from "components";
import { ROUTE_PATH } from "utils/constants/routePath";
import { IMG_PATH } from "utils/constants/imgPath";
import { RenderCommaMoney } from "utils/functions/formatMoney";
import PaymentVerifyWidget from "widgets/PaymentVerifyWidget";

const BookingSkechedule = ({
  theme_standard,
  _id,
  additional_equipment,
  alternative_booking_dates,
  booking_date,
  booking_date_history,
  booker_email,
  booker_phone,
  booker_first_name,
  booker_last_name,
  event_name,
  event_type,
  expected_attendees,
  event_start_time,
  event_end_time,
  event_status,
  payments,
  setup_cleanup_start_time,
  setup_cleanup_end_time,
  pricing,
  productName,
  admin_customer_message,
  reason_admin_reject,
  room_type,
  room_name_th,
  room_ref_id,
  special_request_img,
  special_request,
  status,
  is_accept_terms,
  isAutoOpenPayment,
  onAutoOpenedPayment,
  onSuccess,
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });

  const navigate = useNavigate();

  const { i18n, t } = useTranslation(["common", "room"]);

  const [_isBgLoading, _setIsBgLoading] = useState(false);
  const [_isShowPaymentModal, _setIsShowPaymentModal] = useState(false);
  const [_isUploadMode, _setIsUploadMode] = useState(false);

  // ต้องตรงกับ guard ของ API customerReceipt: status 3/4/5 และงานยังไม่ปิด (event_status 3/4/5)
  const isCanNotifyPayment =
    (status === "3" || status === "4" || status === "5") &&
    !(event_status === "3" || event_status === "4" || event_status === "5");
  const paymentList = payments || [];

  const _handleOpenPaymentModal = () => {
    // ยังไม่เคยอัป เปิดมาเจอฟอร์มเลย / เคยอัปแล้ว เปิดมาเจอรายการสลิปก่อน
    _setIsUploadMode(paymentList.length === 0);
    _setIsShowPaymentModal(true);
  };

  const _handleClosePaymentModal = () => {
    _setIsShowPaymentModal(false);
  };

  // มาจากลิงก์ปุ่ม "อัพโหลด สลิป" ในอีเมล: เปิด popup ให้เลย ถ้าตอนนี้ยังแจ้งชำระเงินได้
  // (เช่น ปิดงาน/ยกเลิกไปแล้ว จะไม่เปิด เพราะ API ไม่รับสลิปอยู่ดี)
  useEffect(() => {
    if (isAutoOpenPayment && isCanNotifyPayment) {
      _handleOpenPaymentModal();
      onAutoOpenedPayment && onAutoOpenedPayment();
    }
  }, [isAutoOpenPayment]); // eslint-disable-line react-hooks/exhaustive-deps

  const _handleClickBookingEdit = (isPreview) => {
    switch (room_type) {
      case "1":
        let query = {
          room_booking_id: _id,
          room_id: room_ref_id?._id,
          booking_date: booking_date,
          booker_email: booker_email,
          booker_phone: booker_phone,
          booker_first_name: booker_first_name,
          booker_last_name: booker_last_name,
          event_name: event_name,
          event_type: event_type,
          expected_attendees: expected_attendees,
          event_end_time: event_end_time,
          event_start_time: event_start_time,
          setup_cleanup_end_time: setup_cleanup_end_time,
          setup_cleanup_start_time: setup_cleanup_start_time,
          is_accept_terms: is_accept_terms,
        };
        if (alternative_booking_dates && alternative_booking_dates.length > 0) {
          // ฟอร์มอ่านวันสำรองเป็น JSON เพราะแต่ละวันมีเวลาของตัวเอง
          query.alternative_booking_dates = JSON.stringify(
            alternative_booking_dates.map((e) => ({
              booking_date: moment(e.booking_date).format("YYYY-MM-DD"),
              setup_cleanup_start_time: e.setup_cleanup_start_time,
              setup_cleanup_end_time: e.setup_cleanup_end_time,
              event_start_time: e.event_start_time,
              event_end_time: e.event_end_time,
            })),
          );
        }
        if (special_request) {
          query.special_request = special_request;
        }
        if (special_request_img) {
          query.special_request_img = special_request_img;
        }
        if (additional_equipment) {
          let reduce = additional_equipment.reduce(
            (result, data) => {
              if (data.subtotal === 0) {
                result.additional_equipment_provider.push(data);
              } else {
                result.additional_equipment_additional.push(data);
              }
              return result;
            },
            {
              additional_equipment_provider: [],
              additional_equipment_additional: [],
            }
          );
          if (reduce.additional_equipment_additional.length > 0) {
            query.additional_equipment_additional =
              reduce.additional_equipment_additional
                .map((e) => e.equipment_ref_id)
                .join(",");
          }
          if (reduce.additional_equipment_provider.length > 0) {
            query.additional_equipment_provider =
              reduce.additional_equipment_provider
                .map((e) => e.equipment_ref_id)
                .join(",");
          }
        }
        if (isPreview) {
          query.is_preview = true;
        }
        const queryString = new URLSearchParams(query).toString();
        //localhost:3000/system/music-hall-detail/6913fddf8682dc3a88f16b7c/booking/3?additional_equipment_additional=6912f3a8431bbf96c7b48e77&additional_equipment_provider=6912f370431bbf96c7b48e73&booker_email=ff%40mail.com&booker_first_name=moopig&booker_last_name=dev&booker_phone=0623080477&booking_date=Sat+Nov+15+2025+00%3A00%3A00+GMT%2B0700+%28Indochina+Time%29&end_date=2025-11-15&event_end_time=14.00&event_name=Ev1&event_start_time=13.00&event_type=1&expected_attendees=22&room_id=6913fddf8682dc3a88f16b7c&setup_cleanup_end_time=11.00&setup_cleanup_start_time=10.00&start_date=2025-11-09&is_accept_terms=true&special_request_img=public%2Ffiles%2Froom%2Fimage%2Froom-40-1763184870306.png&special_request=ddf&room_booking_id=691810e8101a2ed671c5bd0d&is_preview=true
        navigate(
          `${ROUTE_PATH.MUSIC_HALL}/${room_ref_id?._id}/booking/1?${queryString}`
        );
        break;
      case "2": {
        // ต้องพาข้อมูลเดิมไปให้ครบ ไม่งั้นกดแก้แล้วบันทึกร่างใหม่ ค่าที่ไม่ได้ส่งจะหาย
        // - special_request (หมายเหตุ) จะถูกเขียนทับเป็นค่าว่าง
        // - booker_* (ข้อมูลติดต่อ) API จะใช้ข้อมูลสมาชิกแทนที่ลูกค้ากรอกไว้
        let practiceQuery = {
          room_ref_id: room_ref_id?._id,
          event_end_time: event_end_time,
          event_start_time: event_start_time,
          booking_date: booking_date,
          room_booking_id: _id,
          booker_first_name: booker_first_name || "",
          booker_last_name: booker_last_name || "",
          booker_email: booker_email || "",
          booker_phone: booker_phone || "",
        };
        if (special_request) {
          practiceQuery.special_request = special_request;
        }
        if (isPreview) {
          practiceQuery.is_preview = true;
        }
        navigate(
          `${ROUTE_PATH.MUSIC_PRACTICE_ROOM}/${
            room_ref_id?._id
          }/booking/1?${new URLSearchParams(practiceQuery).toString()}`
        );
        break;
      }
      default:
        break;
    }
  };

  const _handleClickViewDetail = () => {
    navigate(`${ROUTE_PATH.MUSIC_HALL_AND_PRACTICE}/${_id}/info`);
  };

  const _handleCancel = () => {
    AlertControl.show({
      title: "ยืนยันการยกเลิกการจอง",
      description: "คุณต้องการยกเลิกการจองใช่หรือไม่",
      btnLabel1: "กลับ",
      btnLabel2: "ตกลง",
      onEvent2: async () => {
        _setIsBgLoading(true);
        let res = await userService.PATCH_ROOM_BOOKING_CANCEL(_id);
        if (res && res.status === 200) {
          _setIsBgLoading(false);
          toast.success(t("Booking cancelled successfully", { ns: "common" }));
          onSuccess && onSuccess();
        } else {
          _setIsBgLoading(false);
          toast.error(t("Booking cancellation failed", { ns: "common" }));
        }
      },
    });
  };

  const renderStatus = ROOM_BOOKING_RENDER_STATUS(status);
  const dateChanged = RENDER_BOOKING_DATE_CHANGED(
    booking_date,
    booking_date_history,
  );
  return (
    <>
      <Displays.BGLoading visible={_isBgLoading} />
      <BookingSkecheduleStyled
        className={customClass}
        statusColor={renderStatus.bgColor}
        textColor={renderStatus.txtColor}
      >
        <div className="booking_box">
          <div className="booking_show">
            {i18n.language === "en"
              ? renderStatus.labelEn
              : renderStatus.labelTh}
          </div>
          <div className="booking_detail">
            <div className="name_label">{room_name_th}</div>
            <div>{productName}</div>
            <div>{moment(booking_date).format("dddd DD MMMM YYYY")}</div>
            {room_type === "1" && setup_cleanup_start_time ? (
              <>
                <div>
                  {t("Set-up & Clean-out Time", { ns: "room" })}{" "}
                  {setup_cleanup_start_time} - {setup_cleanup_end_time}
                </div>
                <div>
                  {t("Exact Event Time", { ns: "room" })} {event_start_time} -{" "}
                  {event_end_time}
                </div>
              </>
            ) : (
              <div>
                {t("Time", { ns: "common" })} {event_start_time} -{" "}
                {event_end_time}
              </div>
            )}
            {/* ห้องซ้อม: หมายเหตุที่ลูกค้ากรอกไว้ (special_request) แสดงเฉพาะตอนมี */}
            {room_type === "2" && special_request && (
              <div className="booking_note">
                {t("Note", { ns: "room" })}: {special_request}
              </div>
            )}
            {dateChanged && (
              <div className="booking_date_changed">
                <div className="bdc_title">
                  {t("Event date changed from", { ns: "room" })}{" "}
                  {moment(dateChanged.from).format("dddd DD MMMM YYYY")}
                </div>
                {dateChanged.reason && (
                  <div className="bdc_reason">
                    {t("Reason", { ns: "common" })}: {dateChanged.reason}
                  </div>
                )}
              </div>
            )}
            {/* ข้อความที่แอดมินกรอกใน popup Status ฝั่ง portal (หน้าตาเดียวกับบรรทัดหมายเหตุ) */}
            {admin_customer_message && (
              <div className="booking_note">
                {t("Message from admin", { ns: "room" })}:{" "}
                {admin_customer_message}
              </div>
            )}
          </div>
          {status === "1" && (
            <>
              <div
                className="booking_detail_button"
                onClick={_handleClickBookingEdit}
              >
                {t("Booking details", { ns: "room" })}
              </div>
              <div className="booking_cancelbutton" onClick={_handleCancel}>
                {t("Cancel booking", { ns: "common" })}
              </div>
            </>
          )}
          {status === "2" && (
            <>
              <div
                className="booking_detail_button"
                onClick={_handleClickViewDetail}
              >
                {t("Booking details", { ns: "room" })}
              </div>
            </>
          )}
          {status === "3" && (
            <>
              <div className="booking_payment">
                <div className="booking_paymentdetail">
                  {t("Payment Details", { ns: "common" })}
                </div>
                <div className="booking_pleasetransfer">
                  <div>{t("Please transfer", { ns: "common" })}</div>
                  <div>
                    {RenderCommaMoney(pricing?.advance_booking_amount)}{" "}
                    {t("THB", { ns: "common" })}
                  </div>
                </div>
              </div>
              <div
                className="booking_detail_button"
                onClick={_handleClickViewDetail}
              >
                {t("Booking details", { ns: "room" })}
              </div>
            </>
          )}
          {status === "4" && (
            <>
              <div
                className="booking_detail_button"
                onClick={_handleClickViewDetail}
              >
                {t("Booking details", { ns: "room" })}
              </div>
            </>
          )}
          {status === "5" && (
            <>
              <div
                className="booking_detail_button"
                onClick={_handleClickViewDetail}
              >
                {t("Booking details", { ns: "room" })}
              </div>
            </>
          )}
          {(status === "6" || status === "8") && (
            <>
              {reason_admin_reject && (
                <div className="booking_admin_edit">
                  {t("Reason for cancellation", { ns: "common" })}
                  <div>{reason_admin_reject}</div>
                </div>
              )}
              <div
                className="booking_detail_button"
                onClick={_handleClickViewDetail}
              >
                {t("Booking details", { ns: "room" })}
              </div>
            </>
          )}

          {isCanNotifyPayment && (
            <div
              className="booking_detail_button booking_payment_button"
              onClick={_handleOpenPaymentModal}
            >
              {t("Payment notification", { ns: "common" })}
            </div>
          )}

          {/* {status === "2" && (
            <div className="booking_cancelbutton" onClick={_handleCancel}>
              ยกเลิกการจอง
            </div>
          )} */}
        </div>
        <Modals.BodyEmpty
          isShowModal={_isShowPaymentModal}
          onCloseModal={_handleClosePaymentModal}
        >
          <div className="payment_modal">
            <div className="pm_header">
              <div className="pm_title">
                {t("Payment notification", { ns: "common" })}
              </div>
              <div className="pm_close" onClick={_handleClosePaymentModal}>
                <Icons.Close width={16} height={16} color="#4B1E78" />
              </div>
            </div>
            {paymentList.length > 0 && (
              <div className="pm_list">
                <div className="pm_list_title">
                  {t("Uploaded slips", { ns: "common" })}
                </div>
                {paymentList.map((p, i) => {
                  const isVerified = p.acknowledged_status === "2";
                  return (
                    <div key={p._id || i} className="pm_item">
                      <div className="pm_row">
                        <div>
                          {moment(p.paid_at || p.created_at).format(
                            "DD/MM/YYYY HH:mm"
                          )}
                        </div>
                        <div className="pm_amount">
                          {RenderCommaMoney(p.transfer_amount)}{" "}
                          {t("THB", { ns: "common" })}
                        </div>
                      </div>
                      <div className="pm_row">
                        <div
                          className={cx("pm_status", {
                            verified: isVerified,
                          })}
                        >
                          {isVerified
                            ? t("Verified", { ns: "common" })
                            : t("Pending admin verification", { ns: "common" })}
                        </div>
                        {p.slip_upload && (
                          <a
                            className="pm_link"
                            href={IMG_PATH + p.slip_upload}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {t("View slip", { ns: "common" })}
                          </a>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            {_isUploadMode ? (
              <PaymentVerifyWidget room_booking_id={_id} onSuccess={onSuccess} />
            ) : (
              <div
                className="booking_detail_button"
                onClick={() => _setIsUploadMode(true)}
              >
                {t("Upload more slip", { ns: "common" })}
              </div>
            )}
          </div>
        </Modals.BodyEmpty>
      </BookingSkecheduleStyled>
    </>
  );
};

BookingSkechedule.propTypes = {};

export default BookingSkechedule;
